export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_55-9e7e6f976be3f8983b9f1f9997414063.jpg";